import React from 'react';
import { } from '@mui/material';
import CtmsHerosection from '../components/CTMS/CtmsHerosection';
import IntrinsicCtms from '../components/CTMS/IntrinsicCtms';

const ProductCtms = () => {
  

  return (
    <>
      <CtmsHerosection />
      <IntrinsicCtms/>

      
    </>
  );
};

export default ProductCtms;
